import styled from 'styled-components';

export const Container = styled.div`
  div.active {
    background-color: #435167;
    color: ${(props) => props.theme.$white};
    height: 81px;
  }
  div.desativada {
    background-color: ${(props) => props.theme.$white};
    height: 81px;
    border: 1px solid #dadada;
    cursor: pointer;
  }

  .tab-immminence {
    p {
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
    }

    span {
      font-size: 12px;
      line-height: 14px;
    }
  }
`;
